import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Employee = apiContainer.Employee
const UserRights = apiContainer.UserRights
//GET--->
// Corrected getEmployee function
export async function getEmployeeApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Employee}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export async function getUserRightsApi(UserRightsId) {
    try {
        return api.get(`${UserRights}/${UserRightsId}`,);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

//CREATE---->
export async function createEmployee(request) {
    try {
        return api.create(`${Employee}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE USERRIGHTS---->
export async function createUserRights(request) {
    try {
        return api.create(`${UserRights}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateEmployee(request, EmployeeId) {
    try {
        return api.update(`${Employee}/${EmployeeId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//STATUS---->
export async function updateEmployeeStatus(request, EmployeeId) {
    try {
        return api.update(`${Employee}/status/${EmployeeId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREDENTIALS---->
export async function updateEmployeeCredentials(request, EmployeeId) {
    try {
        return api.create(`${Employee}/password/${EmployeeId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteEmployee(EmployeeId) {
    try {
        return api.delete(`${Employee}/${EmployeeId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



